import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';

const usePoll = ({
  gameId,
  roundId,
  isAuthenticated,
}: {
  gameId?: string;
  roundId?: string;
  isAuthenticated: boolean;
}) => {
  const { data, isFetching } = useQuery(
    ['poll', roundId, gameId],
    async _ => {
      if (!gameId || !roundId) return Promise.resolve(undefined);
      if (isAuthenticated)
        return backendService.instance.game.retrievePoll({ roundId, gameId });
      return backendService.instance.game.retrievePublicPoll({ roundId, gameId });
    },
    {
      enabled: Boolean(gameId && roundId),
    },
  );

  return {
    data,

    isLoading: isFetching,
  };
};
export default usePoll;
